import { getProjects } from 'owa-timestream-store';
import type { TimeStreamProject } from 'owa-timestream-types';
import { OutlookCalendarAppName } from '../constants';

/**
 * Gets all projects that should be displayed in Calendar Board view.
 * @returns projects that include the calendar app name or have no app name.
 */
export default function getBoardProjects(): TimeStreamProject[] {
    return getProjects(OutlookCalendarAppName, true /* getNonAppSpecificProjects */);
}
